import { swoopAPI } from '@/api'

// For all forms
export const getAllForms = () => swoopAPI.get('/api/v1/forms')

// new endpoints
export const createUser = data => swoopAPI.post('/api/v1/FormUser', data)

export const getForm = (formId, formSectionType) => swoopAPI.get(`/api/v1/form/section/new?${formId ? `&formId=${formId}` : '&index=1'}&formSectionType=${formSectionType}`)

export const getFormSection = (formSectionType, index = null, formId = null) =>
  swoopAPI.get(`/api/v1/form/section/new?${index ? `index=${index}&` : ''}formSectionType=${formSectionType}${formId ? `&formId=${formId}` : ''}`)

export const getFilledFormSection = (companyId, formSectionType, index = null, formId = null) =>
  swoopAPI.get(`/api/v1/form/section/company/${companyId}/new?${index ? `index=${index}&` : ''}formSectionType=${formSectionType}${formId ? `&formId=${formId}` : ''}`)

export const postFormSection = payload => swoopAPI.post('/api/v1/form/section', payload)

export const postForm = payload => swoopAPI.post('/api/v1/FormUser/new', payload)

export const postFormExternal = payload => swoopAPI.post('/api/v1/FormUser/new/external', payload)

export const createApiIntegrationUser = payload => swoopAPI.post('/api/v1/user/set-password', payload)
